package br.com.vvrefeicoes.portal.feature.placeholder

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.ui.components.AppFooter
import br.com.vvrefeicoes.portal.core.ui.layout.AppScrollColumn
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import org.jetbrains.compose.resources.painterResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.undrawable_under_construction

private const val ILLUSTRATION_ASPECT_RATIO = 800f / 270f

@Composable
fun PlaceholderScreen(title: String) {
    AppScrollColumn(
        modifier = Modifier.fillMaxSize(),
        contentPadding = PaddingValues(AppSpacing.space24),
        footer = { AppFooter() },
    ) {
        Text(
            text = title,
            style = MaterialTheme.typography.headlineMedium,
        )
        Box(
            modifier =
                Modifier
                    .fillMaxWidth()
                    .padding(vertical = AppSpacing.space48),
            contentAlignment = Alignment.Center,
        ) {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(AppSpacing.space48),
            ) {
                Image(
                    painter = painterResource(Res.drawable.undrawable_under_construction),
                    contentDescription = null,
                    modifier =
                        Modifier
                            .widthIn(max = 720.dp)
                            .fillMaxWidth(0.9f)
                            .aspectRatio(ILLUSTRATION_ASPECT_RATIO),
                    contentScale = ContentScale.Fit,
                )
                Text(
                    text = "Em construção",
                    style = MaterialTheme.typography.titleLarge,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            }
        }
    }
}
